import React from "react";
import Link from "next/link";
import { getSlugForSolution } from "../../utils/solutionSlug";
import { dispatchNewEvent } from "../../utils/analytics/trigger/analyticsTrigger";
import styles from "./faq-popular-solutions.module.scss";

function FAQPopularSolutions({ solutions }) {
  const onClick = () =>
    dispatchNewEvent("dataStateChange", {
      action: "faq.Event",
      type: "popularViewed",
    });

  return (
    <div className={styles.faqPopularSolutions} data-test="faq-popular-solutions">
      <h2 className={styles.faqPopularSolutions__header}>Popular questions</h2>
      <ol className={styles.faqPopularSolutions__list}>
        {solutions.map(solution => (
          <li key={solution.id} className={styles.faqPopularSolutions__listItem}>
            <Link
              data-test="faq-popular-solution-link"
              href={`/faq/${getSlugForSolution(solution)}`}
              className={styles.faqPopularSolutions__link}
              onClick={onClick}
            >
              {solution.title}
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default FAQPopularSolutions;
